import CryptoJS from "crypto-js";
import config from "./config";

function encrypt(data){
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      config.SECRET_KEY
    ).toString();
    return encryptedData;
  }

function decrypt(data){
    const bytes = CryptoJS.AES.decrypt(data, config.SECRET_KEY);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  }

const utils = { encrypt, decrypt };

export default utils;